import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {NavController} from "@ionic/angular";
import {User} from "../../services/models/User/User";

@Component({
  selector: 'app-points',
  templateUrl: './points.component.html',
  styleUrls: ['./points.component.scss'],
})
export class PointsComponent implements OnInit {
  @Input()userData!: User;
  lastUserPoints: number = 0;
  blinking: boolean = false;
  audio = new Audio('https://starteremponagrody.pl/sounds/coin.wav');
  constructor(private navCtrl: NavController) {

  }
  animateValueChange(from: number, to: number, duration: number): void {
    if (from === 0 || from === to) {
      this.lastUserPoints = to;
      return;
    }
    this.blinking = true;
    const totalSteps = Math.abs(to - from); // Total steps to animate
    if (totalSteps === 0) return; // No animation needed if values are the same

    const interval = duration / totalSteps; // Time interval per step
    const step = to > from ? 1 : -1;        // Determine the direction of the animation

    const timer = setInterval(() => {
      if (from === to) {
        clearInterval(timer); // Stop the interval when the target value is reached
        this.blinking = false;
      } else {
        this.audio.play();
        from += step;
        this.lastUserPoints = from; // Update the displayed value
      }
    }, interval);

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['userData'] && changes['userData'].currentValue) {
      this.animateValueChange(this.lastUserPoints, changes['userData'].currentValue.userWallets[1].balance, 500);
      //this.lastUserPoints = changes['userData'].currentValue.userWallets[1].balance;
    }
  }
  ngOnInit() {

  }
  button_click() {
    this.navCtrl.navigateForward('/secured/transfer');
  }
}
